/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialModule } from 'src/app/common/material/material-module';
import { TicketEditSheetComponent } from './components/ticket-edit-sheet/ticket-edit-sheet.component';
import { FileAttachModule } from '../file-attach/file-attach.module';
import { DockedTicketModule } from 'src/app/common/docked-ticket/docked-ticket.module';
import { CommonComponentsModule } from 'mobile/app/common-components/common-components.module';
import { SharedUIMaterialModule } from 'src/app/shared/ui/material/shared-ui-material.module';

@NgModule({
	declarations: [TicketEditSheetComponent],
	imports: [
		CommonModule,
		MaterialModule,
		FileAttachModule,
		DockedTicketModule,
		CommonComponentsModule,
		SharedUIMaterialModule,
	],
	exports: [TicketEditSheetComponent],
})
export class TicketEditPanelModule {}
